app.controller('BrowseProductIndividualDoorSlopingCalculatorController', ['$rootScope', '$scope', '$bootstrapModal', function ($rootScope, $scope, $bootstrapModal) {

    const siteHelper = $rootScope.site_helper;
    const navigationIDs = $scope.navigation_ids;

    const productModel = $rootScope.factory.product_door_sloping_calculator.getModel(navigationIDs);
    $scope.product = productModel.product;

    $scope.alt_product_hrefs = {};

    const documentProductTag = "door_sloping";

    $scope.product_document = null;
    $rootScope.service.cache_local_server.productDocumentsByTags([navigationIDs.site_range_id, documentProductTag], function (documents) {
        $scope.product_document = documents.length > 0 ? documents[0] : null;
    })

    productModel.apiRequest(function () {
        $scope.product = productModel.product;
    });

    function addDoorSlopingHref() {

        const componentObject = $rootScope.service.cache_local_server.getComponentObject(productModel.base_component_id, null, "door_sloping");
        if (!$rootScope.service.cache_local_server.isComponentObjectAvailable(componentObject, navigationIDs.site_range_id, navigationIDs.colour_id, navigationIDs.style_id)) {
            return;
        }

        const routeIDs = siteHelper.simpleCloneObject(navigationIDs);
        routeIDs.tile_id = "door_sloping";
        delete routeIDs.parent_category_id;


        $scope.alt_product_hrefs.door_sloping = $rootScope.navigation_manager.createNavigationModel(null, routeIDs).href;
    }

    addDoorSlopingHref();

    $scope.editDoorSloping = function (doorProduct, formScope) {


        $bootstrapModal.open({
            templateUrl: 'BrowseCustomModalProductDoorSlopingCalculator.html',
            controller: 'CommonModalSimpleController',
            //size: 'md',
            resolve: {
                items: {
                    calculator_product: $scope.product,
                    door_product: doorProduct,
                    applyMidrail: function (doorProduct) {
                        if (doorProduct.midrail_option) {
                            let midrailHeight = $scope.product.option_term_values.midrail ? $scope.product.option_term_values.midrail.midrail_height : null;
                            midrailHeight = midrailHeight ? midrailHeight : $scope.product.default_midrail_height;
                            doorProduct.midrail = midrailHeight;
                        } else {
                            doorProduct.midrail = false;
                        }

                    },
                    callback: function () {
                        doorProduct.hinge_holes = $rootScope.service.product_door_sloping_calculator.getDoorProductHingeHoles(doorProduct)

                        //validateForm(checkPriceHandler, product, 'cart_check_price')
                        if (formScope && formScope.validateForm && formScope.checkPriceHandler) {
                            formScope.validateForm(formScope.checkPriceHandler, $scope.product, 'cart_check_price');
                        }
                    }
                }
            }
        });
    };

    $scope.applyMidrail = function (index) {

        const doorProduct = $scope.product.door_products[index];

        if (doorProduct.midrail_option) {
            let midrailHeight = $scope.product.option_term_values.midrail ? $scope.product.option_term_values.midrail.midrail_height : null;
            midrailHeight = midrailHeight ? midrailHeight : $scope.product.default_midrail_height;
            doorProduct.midrail = midrailHeight;
        } else {
            doorProduct.midrail = false;
        }

    };

    $scope.checkPriceHandler = function (validateFormCallback, product) {

        $rootScope.service.product.addToCart(collectOrderBuild(product), function (success, messages, orderLine) {

            if (orderLine) {
                for (let i = 0; i < orderLine._sublines.length; i++) {
                    const subline = orderLine._sublines[i];
                    let doorProduct = product.door_products[i];
                    if (!doorProduct) {
                        doorProduct = subline;
                        product.door_products[i] = doorProduct;
                        doorProduct.initialized = false;
                        doorProduct.midrail_option = !!subline.midrail;
                    } else {
                        for (let key in subline) {
                            doorProduct[key] = subline[key];
                        }
                    }
                }

                product.calculated_price = orderLine._sublines_price;

                if (!success) {
                    product.check_price_errors = true;
                }
                $rootScope.service.product_door_sloping_calculator.applyDoorSlopingProducts(product)
            }
            if (validateFormCallback) {
                validateFormCallback(success, messages);
            }
        }, true);

    };

    $scope.addToCartHandler = function (validateFormCallback, product) {

        $rootScope.service.product.addToCart(collectOrderBuild(product), function (success, messages, orderLine) {
            if (success) {
                $rootScope.service.product.resetProduct(product);

                product.doors = '';
                product.width = '';
                product.height = '';
                product.door_sloping_count = '';


                product.applynonstdsurcharge = false;
                product.calculated_price = 0;

                product.sublines = '';

                product.rotate_grain = false;

                product.door_products = [];
            }
            if (validateFormCallback) {
                validateFormCallback(success, messages);
            }
        }, false);
    };

    function collectOrderBuild(product) {

        const doorOptions = [];
        product.check_price_errors = false;
        for (let i = 0; i < product.door_sloping_count; i++) {
            const doorProduct = product.door_products[i];
            let doorOption;
            if (doorProduct) {
                delete doorProduct._errors;
                doorOption = {
                    drill_0: doorProduct.drill_0,
                    drill_1: doorProduct.drill_1,
                    drill_2: doorProduct.drill_2,
                    drill_3: doorProduct.drill_3,
                    drill_4: doorProduct.drill_4,
                    drill_5: doorProduct.drill_5,
                    drillside: doorProduct.drillside,
                    midrail: doorProduct.midrail
                }
                if (siteHelper.isNumber(doorProduct.inputted_width)) {
                    doorOption.width = doorProduct.inputted_width;
                }
            } else {
                doorOption = {};
            }
            doorOption.handle_position = product.option_term_ids.handle_position_knebworth;
            doorOptions.push(doorOption);
        }


        const orderLine = {

            type: product.api_code,

            quantity: product.quantity,
            cost: product.displayPrice(),

            range: product.getSubmitRangeID(),
            colour: navigationIDs.colour_id,
            style: navigationIDs.style_id,

            height: product.height,
            width: product.width,

            rotate_grain: product.rotate_grain,

            midrail: product.option_term_values.midrail ? product.option_term_values.midrail.midrail_height : null,

            left_angle_height: product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.left_angle_height : null,
            left_angle_width: product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.left_angle_width : null,
            right_angle_height: product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.right_angle_height : null,
            right_angle_width: product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.right_angle_width : null,

            door_options: doorOptions,

            doors: product.door_sloping_count,

            door_spacing: product.option_term_values.door_sloping_spacing ? product.option_term_values.door_sloping_spacing.door_spacing : null,

            left_spacing: product.option_term_values.door_sloping_spacing ? product.option_term_values.door_sloping_spacing.left_spacing : null,
            right_spacing: product.option_term_values.door_sloping_spacing ? product.option_term_values.door_sloping_spacing.right_spacing : null,
            top_spacing: product.option_term_values.door_sloping_spacing ? product.option_term_values.door_sloping_spacing.top_spacing : null,
            bottom_spacing: product.option_term_values.door_sloping_spacing ? product.option_term_values.door_sloping_spacing.bottom_spacing : null,

            left_angle_spacing: product.option_term_values.door_sloping_spacing ? product.option_term_values.door_sloping_spacing.left_angle_spacing : null,
            right_angle_spacing: product.option_term_values.door_sloping_spacing ? product.option_term_values.door_sloping_spacing.right_angle_spacing : null,

            product_model_id: product.model_id,
            parent_category_ids: product.parent_category_ids,

            group_name: product.group_name
        };


        return {
            range: orderLine.range,
            colour: orderLine.colour,
            style: orderLine.style,
            lines: [orderLine]
        };

    }

}]);